/* eslint-disable @typescript-eslint/no-explicit-any */
import { axios } from "../../lib/axios";
import { ApiError } from "../../types/ApiError";
import { CBQSessionPayload } from "./cbqStudentTypes";

type GetCBQSessionResponse = {
  statusCode?: number;
  error?: ApiError | null;
  data?: CBQSessionPayload;
};

// GET /cbq/sessions/:cbqSessionId — full session payload for the renderer.
export const GetCBQSession = async (
  cbqSessionId: string
): Promise<GetCBQSessionResponse> => {
  try {
    const response = await axios.get(`/cbq/sessions/${cbqSessionId}`);
    return { data: response.data?.data ?? response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data?.message,
        error: error.response.data?.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
